import React from 'react';
import PropTypes from 'prop-types';

// COMPONENTS
import List from '../../Framework/Pages/List/List';
import Text from '../../Framework/Components/Text';
import EditChange from '../../Framework/Components/Buttons/EditChange';
import Boolean from '../../Framework/Components/Boolean';

const ProductChangeRequestList = (props) => {
    return (
        <List {...props} readonly>
            <Text name="id" />
            <EditChange name="name" />
            <Boolean name="original" />
        </List>
    );
};

export default ProductChangeRequestList;

ProductChangeRequestList.propTypes = {
    /**
     * Type of entity
     */
    entity: PropTypes.object,
};

ProductChangeRequestList.defaultProps = {
    entity: {},
};
